import StyledLabel from 'Components/StyledLabel'
import TranslationInput from 'Components/TranslationInput'
import type { ParameterGroupParameter } from 'Services/ProductManagement/Features/Parameter/types'
import type { ParameterTranslation } from 'Store'
import { Box, TextField, Typography } from '@mui/material'
import type { default as React } from 'react'
import { t } from 'ttag'

export function ParameterFormFields({
  parameterGroupParameter,
  handleSetDetails,
  isEdit
}: Readonly<{
  parameterGroupParameter: ParameterGroupParameter
  handleSetDetails: (
    value: string | ParameterTranslation[],
    name: keyof ParameterGroupParameter
  ) => void
  isEdit: boolean
}>) {
  const handleTextInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    handleSetDetails(value, name as keyof ParameterGroupParameter)
  }
  const handleSetTranslations = (updatedTranslations: ParameterTranslation[]) => {
    handleSetDetails(updatedTranslations, 'translations')
  }

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <TextField
          sx={{ minWidth: 200, mr: 2 }}
          required
          disabled={isEdit}
          label={t`Identifier`}
          name={'parameter_id'}
          value={parameterGroupParameter?.parameter_id}
          onChange={handleTextInputChange}
        />
        <TextField
          sx={{ minWidth: 200 }}
          required
          label={t`Name`}
          name={'parameter_name'}
          value={parameterGroupParameter?.parameter_name}
          onChange={handleTextInputChange}
        />
      </Box>
      <Box>
        <StyledLabel>{t`Translations`}</StyledLabel>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography fontSize={18} sx={{ mr: 1, minWidth: 30 }} color="text.secondary">
            FI
          </Typography>
          <TranslationInput
            translations={parameterGroupParameter.translations}
            field="value"
            label={t`Name`}
            locale={'fi'}
            setTranslations={handleSetTranslations}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography fontSize={18} sx={{ mr: 1, minWidth: 30 }} color="text.secondary">
            SV
          </Typography>
          <TranslationInput
            sx={{ my: 0 }}
            translations={parameterGroupParameter.translations}
            field="value"
            label={t`Name`}
            locale={'sv'}
            setTranslations={handleSetTranslations}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography fontSize={18} sx={{ mr: 1, minWidth: 30 }} color="text.secondary">
            EN
          </Typography>
          <TranslationInput
            translations={parameterGroupParameter.translations}
            field="value"
            label={t`Name`}
            locale={'en'}
            setTranslations={handleSetTranslations}
          />
        </Box>
      </Box>
    </>
  )
}
